import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';

import { IResultEnfriadores, IRNLoginResponse } from '../../shared/models/Enfriadores.model';
import { TENDERO_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorEnfriadores,
    getEnfriadores,
    successEnfriadores,
} from '../actions/enfriadores.actions';

@Injectable()
export class EnfriadoresEffects {

    constructor(
        private actions$: Actions,
        private httpS: SharedServiceService
    ) { }

    /**
     * * Obtiene los datos de enfriadores para conexión url
     */
    public getEnfriadores$ = createEffect(
        () => this.actions$.pipe(
            ofType(getEnfriadores),
            switchMap(() => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.get_rn_login_url, {})
                .pipe(
                    map((resp: IRNLoginResponse) => {
                        if (resp.successful && resp.data?.url) {
                            return successEnfriadores({
                                success: true,
                                message: resp.message,
                                data: {
                                    url_module: resp.data.url
                                }
                            } as IResultEnfriadores);
                        }
                        throw new Error(resp.message || 'URL del módulo no disponible');
                    }),
                    catchError((err: Error | any) => {
                        const error = err instanceof Error ? err : new Error(err?.message || 'Error en la petición de enfriadores');
                        return of(errorEnfriadores({ payload: error }));
                    }),
                )),
        )
    );
}
